import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { calcStatusByPercentageCompletion } from '../../functions';
import { changePercentageItemByPercent } from '../../gantChangeData';
import { RootState } from '../../store';
import { ItemType, MappingItemIdIndexType } from '../../types';

const useControlPercentage = (
    values: ItemType,
    bufferItems: React.MutableRefObject<ItemType[]>,
    saveBufferToStore: () => void,
    updatedItem?: ItemType,
) => {
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);

    useEffect(() => {
        if (!values || !updatedItem) {
            return;
        }

        const previousItem = bufferItems.current[mappingItemIdIndex[updatedItem.id]];

        if (values.completionPercentage === previousItem.completionPercentage) {
            return;
        }

        bufferItems.current = [...bufferItems.current];
        bufferItems.current[mappingItemIdIndex[updatedItem.id]] = {
            ...previousItem,
            completionPercentage: values.completionPercentage,
            status: calcStatusByPercentageCompletion(values.completionPercentage),
        } as ItemType;

        bufferItems.current = changePercentageItemByPercent(
            mappingItemIdIndex,
            values.completionPercentage,
            updatedItem,
            itemsList,
        );
        saveBufferToStore();
    }, [values?.completionPercentage]);

    return [];
};

export default useControlPercentage;
